export const convertDateStringApiToUser = (date: string) => {
	return `${date.substring(4, 6)}/${date.substring(6)}/${date.substring(0, 4)}`;
};

export const convertDateStringUserToApi = (date: string) => {
	const [MM, dd, yyyy] = date.split('/');

	return yyyy + MM + dd;
};
